var _style, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyzskDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 72",
    style: {
      enableBackground: "new 0 0 50 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 25.4,
    className: "st0",
    width: 8.1,
    height: 14.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 28.1,
    className: "st1",
    width: 8.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    className: "st0",
    width: 8.1,
    height: 20.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,52.2v-6.1h2.3l1.4,4.2l1.4-4.2h2.3v6.1h-1.4v-4.8l-1.5,4.8H8.9l-1.5-4.8v4.8H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.8,52.2v-2.6L14,46.1h1.8l1.8,2.4l1.7-2.4h1.8l-2.8,3.6v2.6H16.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,52.2v-1.2h1.5v1.2H20.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,52.2v-1.1l4-4h-3.5v-1H29v1l-4.1,4.1h4.3v1H23z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.7,50.2l1.5-0.1c0.1,0.4,0.3,0.7,0.5,0.9c0.3,0.2,0.6,0.3,1.1,0.3c0.5,0,0.9-0.1,1.1-0.3 c0.3-0.2,0.4-0.4,0.4-0.6c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.6-0.1-1.2-0.3c-0.8-0.2-1.4-0.4-1.7-0.6 c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.3,0.1-0.6,0.3-0.9c0.2-0.3,0.5-0.5,0.9-0.6c0.4-0.1,0.9-0.2,1.5-0.2c0.9,0,1.7,0.2,2.1,0.5 c0.5,0.3,0.7,0.8,0.8,1.4l-1.5,0.1c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2-0.1-0.5-0.2-1-0.2c-0.4,0-0.8,0.1-1,0.2c-0.2,0.1-0.2,0.2-0.2,0.4 c0,0.1,0.1,0.3,0.2,0.4c0.2,0.1,0.7,0.3,1.4,0.4c0.7,0.1,1.3,0.3,1.6,0.4c0.4,0.2,0.6,0.4,0.8,0.6c0.2,0.3,0.3,0.6,0.3,1 c0,0.4-0.1,0.7-0.4,1c-0.2,0.3-0.6,0.5-1,0.7c-0.4,0.1-1,0.2-1.6,0.2c-1,0-1.7-0.2-2.2-0.5C30.1,51.5,29.8,50.9,29.7,50.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.2,52.2v-6.1h1.5v2.7l3.1-2.7h2.1L41,48.5l3,3.7h-2l-2.1-2.9l-1.2,1v1.9H37.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyzskDefault);
export default __webpack_public_path__ + "static/media/myzsk-default.46b1b18dfd8433895bf2507cd69e23ed.svg";
export { ForwardRef as ReactComponent };